import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { finalize } from 'rxjs/operators';
import { General_Interface } from 'src/app/Interface/General_Interface';
import { IC_DueRow } from 'src/app/Interface/IC_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { DeviceGroupService } from 'src/app/Service/DeviceGroup/DeviceGroup.service';
import { ICService } from 'src/app/Service/IC/IC.service';
import * as XLSX from 'xlsx';
import { Jalali } from 'jalali-ts';

@Component({ selector: 'app-ic-due-list', templateUrl: './ICDueList.component.html', styleUrls: ['./ICDueList.component.css'] })
export class ICDueListComponent implements OnInit {
  rows: IC_DueRow[] = [];
  DataList: IC_DueRow[] = [];
  GroupList: General_Interface[] = [];
  SubGroupList: General_Interface[] = [];
  loading = false;
  loadError = '';
  page = 1;
  executingId?: number;
  FilterForm: FormGroup = this.fb.group({
    TemplateTitle: [''], Status: [''], GroupId: [0], SubGroupId: [{ value: 0, disabled: true }],
    Keyword: [''], DueWindow: ['all'], DueStatus: [''], TemplateId: [0], ScopeWindow: ['all'], ExcludeBlocked: [false]
  });

  constructor(private fb: FormBuilder, private service: ICService, private groupService: DeviceGroupService,
    private router: Router, private alert: AlertifyService, private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.FilterForm.patchValue({ GroupId: Number(this.route.snapshot.queryParamMap.get('groupId')) || 0,
      TemplateId: Number(this.route.snapshot.queryParamMap.get('templateId')) || 0,
      Keyword: this.route.snapshot.queryParamMap.get('equipmentKeyword') || '',
      ScopeWindow: this.route.snapshot.queryParamMap.get('scopeWindow') || 'all',
      ExcludeBlocked: this.route.snapshot.queryParamMap.get('excludeBlocked') === 'true' });
    const window = this.route.snapshot.queryParamMap.get('window');
    if (window === 'today') this.FilterForm.patchValue({ Status: 'DUE', DueWindow: 'today' });
    if (window === 'overdue') this.FilterForm.patchValue({ Status: 'OVERDUE', DueWindow: 'overdue' });
    if (window === 'upcoming') this.FilterForm.patchValue({ DueWindow: 'upcoming' });
    if (window === 'next30') this.FilterForm.patchValue({ DueWindow: 'next30' });
    this.groupService.GetDeviceGroup(0).subscribe({
      next: data => { this.GroupList = data || []; if (Number(this.FilterForm.get('GroupId')?.value) > 0) this.ReadSubGroups(); },
      error: () => this.alert.ErrorMessage('خطا در دریافت گروه‌های تجهیز.')
    });
    this.ReadData();
  }

  ReadData(): void {
    this.loading = true; this.loadError = '';
    const value = this.FilterForm.getRawValue();
    this.service.getDue(value.Status || undefined, undefined, Number(value.TemplateId) || undefined, {
      groupId: Number(value.GroupId) || undefined, subGroupId: Number(value.SubGroupId) || undefined,
      templateTitle: String(value.TemplateTitle || '').trim() || undefined,
      equipmentKeyword: String(value.Keyword || '').trim() || undefined,
      window: value.DueWindow || 'all', dueStatus: value.DueStatus || undefined,
      scopeWindow: value.ScopeWindow === 'all' ? undefined : value.ScopeWindow, excludeBlocked: value.ExcludeBlocked || undefined
    }).pipe(finalize(() => this.loading = false)).subscribe({
      next: data => {
        this.rows = data || [];
        this.DataList = this.rows;
        this.page = 1;
      },
      error: () => { this.rows = []; this.DataList = []; this.loadError = 'دریافت کنترل‌های آماده اجرا ناموفق بود.'; this.alert.ErrorMessage(this.loadError); }
    });
  }

  ReadSubGroups(): void {
    const groupId = Number(this.FilterForm.get('GroupId')?.value || 0);
    this.FilterForm.patchValue({ SubGroupId: 0 });
    this.SubGroupList = [];
    if (groupId <= 0) {
      this.FilterForm.get('SubGroupId')?.disable();
      return;
    }
    this.FilterForm.get('SubGroupId')?.enable();
    this.groupService.GetDeviceGroup(groupId).subscribe({
      next: data => this.SubGroupList = data || [],
      error: () => this.alert.ErrorMessage('خطا در دریافت زیرگروه‌های تجهیز.')
    });
  }

  Clear(): void {
    this.FilterForm.reset({ TemplateTitle: '', Status: '', GroupId: 0, SubGroupId: 0, Keyword: '', DueWindow: 'all', DueStatus: '', TemplateId: 0, ScopeWindow: 'all', ExcludeBlocked: false });
    this.FilterForm.get('SubGroupId')?.disable();
    this.SubGroupList = [];
    this.ReadData();
  }

  execute(row: IC_DueRow): void {
    if (this.executingId || !this.isReady(row)) return;
    this.executingId = row.assignmentItemId;
    this.service.createExecution({ iC_Assignment_Item_ID: row.assignmentItemId, execution_Source: 'SCHEDULED' })
      .pipe(finalize(() => this.executingId = undefined)).subscribe({
        next: result => this.router.navigate(['/ic/execution/add', result.id]),
        error: error => this.alert.ErrorMessage(error?.error?.message || 'شروع اجرا ناموفق بود.')
      });
  }

  isReady(row: IC_DueRow): boolean { return row.canExecute === true; }
  persianDate(value?: string | null): string {
    if (!value) return 'قابل محاسبه نیست';
    try { return Jalali.gregorian(value).format('YYYY/MM/DD'); } catch { return 'قابل محاسبه نیست'; }
  }
  statusTitle(value: string): string {
    return ({ DUE: 'سررسید', DUE_SOON: 'نزدیک سررسید', OVERDUE: 'گذشته از سررسید',
      UPCOMING: 'هنوز موعد نیست', UNKNOWN: 'قابل محاسبه نیست', IN_PROGRESS: 'در حال اجرا', COMPLETED: 'تکمیل‌شده',
      UNDER_REVIEW: 'در انتظار بررسی', WAITING_FOR_APPROVAL: 'در انتظار تأیید' } as any)[value] || value;
  }

  dueClass(status?: string): string { return status === 'OVERDUE' ? 'badge-danger' : status === 'DUE' ? 'badge-warning' : status === 'DUE_SOON' ? 'badge-info' : 'badge-secondary'; }
  daysTitle(days?: number | null): string {
    return days == null ? 'قابل محاسبه نیست' : days === 0 ? 'امروز موعد اجراست' : days > 0 ? `${days} روز تا موعد` : `${-days} روز از موعد گذشته`;
  }

  excelWorkbook(): XLSX.WorkBook {
    const data = this.rows.map(row => ({
      'تجهیز': row.equipmentName || '', 'کد تجهیز': row.equipmentCode || '',
      'گروه': row.group || '', 'زیرگروه': row.subGroup || '',
      'کد الگو': row.templateCode, 'عنوان الگو': row.templateTitle,
      'عنوان آیتم': row.itemTitle, 'دوره': row.periodUsed ?? row.periodDays ?? 'ثبت نشده', 'دوره تنظیم‌شده': row.periodDays ?? 'ثبت نشده',
      'بازه هشدار': row.warningDays ?? 'ثبت نشده', 'آخرین اجرا': row.lastExecutionDate ? this.persianDate(row.lastExecutionDate) : 'بدون سابقه اجرا',
      'اجرای بعدی': this.persianDate(row.nextDueDate), 'شروع هشدار': this.persianDate(row.warningStartDate),
      'روز تا موعد': row.daysToDue ?? 'قابل محاسبه نیست', 'وضعیت موعد': row.dueStatusTitle || this.statusTitle(row.dueStatus || 'UNKNOWN'),
      'وضعیت اجرا': this.statusTitle(row.status)
    }));
    const ws = XLSX.utils.json_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'سررسید کنترل میانی');
    return wb;
  }

  exportExcel(): void { XLSX.writeFile(this.excelWorkbook(), 'گزارش-سررسید-کنترل-میانی.xlsx'); }

}
